import { Fetch, FetchQueue } from "@sopheos/orbjs_fetch";

let _instanceRequest = null;
let _instanceApi = null;

/**
 *
 * @returns {Fetch}
 */
export function useRequest() {
  if (!_instanceRequest) {
    _instanceRequest = new Fetch();
  }
  return _instanceRequest;
}

/**
 *
 * @returns {FetchQueue}
 */
export function useFetchApi() {
  if (!_instanceApi) {
    _instanceApi = new FetchQueue(
      {
        baseUrl: import.meta.env.VITE_API_URL,
      },
      { handleErrors },
    );
  }
  return _instanceApi;
}

async function handleErrors(e) {
  switch (e.status) {
    case 401:
      await useLogout();
      console.error(e);
      break;
    case 500:
      console.error(e);
      break;
    default:
      break;
  }
}
